import React, { Component } from 'react';
import _ from 'lodash';

export default class BetResultAggregatesTable extends Component {
  static getAccumulatedStake(group) {
    return group
      .map(a => Number(a[1].substr(1)))
      .reduce((prev, curr) => prev + curr);
  }

  static getAvgOdds(group, accumulatedStake) {
    const avgOdds = group
      .map(row => Number(row[1].substr(1)) * Number(row[2]))
      .reduce((prev, curr) => prev + curr);

    return avgOdds / accumulatedStake;
  }

  static getProfitLoss(avgOdds, accumulatedStake) {
    return accumulatedStake * (avgOdds - 1);
  }

  getAggregateData() {
    // Group by bet type (first array element)
    const groups = _.groupBy(this.props.data, 0);

    return Object.keys(groups)
      .map((type) => {
        const accumulatedStake = BetResultAggregatesTable.getAccumulatedStake(groups[type]);
        const avgOdds = BetResultAggregatesTable.getAvgOdds(groups[type], accumulatedStake);
        const profitLoss = BetResultAggregatesTable.getProfitLoss(avgOdds, accumulatedStake);

        return {
          type,
          accumulatedStake,
          avgOdds,
          profitLoss,
        };
      });
  }

  render() {
    return (
      <table className="table table-hover">
        <thead>
          <tr>
            <th>Bet type</th>
            <th>Accumulated Stake</th>
            <th>Avg Odds</th>
            <th>P/L</th>
          </tr>
        </thead>
        <tbody>
          {this.getAggregateData().map(row => (
            <tr key={row.type}>
              <td>{row.type}</td>
              <td>€{row.accumulatedStake.toLocaleString('en-GB', { maximumFractionDigits: 2 })}</td>
              <td>{row.avgOdds.toLocaleString('en-GB', { maximumFractionDigits: 3 })}</td>
              <td>€{row.profitLoss.toLocaleString('en-GB', { maximumFractionDigits: 2 })}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BetResultAggregatesTable/BetResultAggregatesTable.js